import { useMediaQuery } from 'react-responsive';

const MOBILE_MAX_WIDTH = 768;

/** Returns true when the viewport is at most {@link MOBILE_MAX_WIDTH}px wide. */
export const useIsMobile = () => useMediaQuery({ maxWidth: MOBILE_MAX_WIDTH });

/**
 * Returns true when the viewport is too narrow to comfortably show layouts
 * that need extra horizontal space (e.g. the OtherInfo desktop split).
 * Falls back to the mobile experience for these layouts.
 */
const NARROW_LAYOUT_MAX_WIDTH = 1024;
export const useIsNarrowLayout = () =>
  useMediaQuery({ maxWidth: NARROW_LAYOUT_MAX_WIDTH });
